/*
  ArmeSiMunitie header behaviour: sticky state, mega panels, mobile drawer
  with drill-down, predictive search (Shopify /search/suggest.json).
  No dependencies. Venture's theme.js keeps running for the rest of the site.
*/
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function cleanTitle(title) {
    return String(title || '').replace(/^\s*xx\s+/i, '');
  }

  /* ---------- Venture compatibility: add-to-cart notifications ---------- */
  function initNotify() {
    if (window.theme && !window.theme.Notify && typeof window.Notify === 'function') {
      try { window.theme.Notify = new window.Notify(); } catch (e) { /* product pages fall back to cart page */ }
    }
  }

  /* ---------- Sticky shadow ---------- */
  function initSticky(header) {
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Mega panels ---------- */
  function initMega(header) {
    var toggles = Array.prototype.slice.call(header.querySelectorAll('[data-ams-mega-toggle]'));
    if (!toggles.length) return;
    var hoverTimer;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function panelFor(toggle) { return document.getElementById(toggle.getAttribute('aria-controls')); }

    function closeAll(except) {
      toggles.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var p = panelFor(t);
        if (p) p.classList.remove('is-open');
      });
    }

    function open(toggle) {
      closeAll(toggle);
      toggle.setAttribute('aria-expanded', 'true');
      var p = panelFor(toggle);
      if (p) p.classList.add('is-open');
    }

    toggles.forEach(function (toggle) {
      var panel = panelFor(toggle);
      toggle.addEventListener('click', function () {
        if (toggle.getAttribute('aria-expanded') === 'true') closeAll(); else open(toggle);
      });
      if (canHover) {
        toggle.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { open(toggle); }, 120);
        });
        toggle.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(closeAll, 200); });
        if (panel) {
          panel.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
          panel.addEventListener('mouseleave', function () { hoverTimer = setTimeout(closeAll, 200); });
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openToggle = toggles.filter(function (t) { return t.getAttribute('aria-expanded') === 'true'; })[0];
      if (openToggle) { closeAll(); openToggle.focus(); }
    });

    document.addEventListener('click', function (e) {
      if (!header.querySelector('.ams-nav') || header.querySelector('.ams-nav').contains(e.target)) return;
      closeAll();
    });

    header.querySelectorAll('[data-ams-mega]').forEach(function (panel) {
      panel.addEventListener('focusout', function (e) {
        if (!panel.contains(e.relatedTarget) && !(e.relatedTarget && e.relatedTarget.hasAttribute('data-ams-mega-toggle'))) {
          closeAll();
        }
      });
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-ams-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-ams-drawer-open]');
    var lastFocus = null;
    var levelOne = drawer.querySelector('[data-level="1"]');

    function resetLevels() {
      drawer.querySelectorAll('[data-level="2"]').forEach(function (l) {
        l.classList.remove('is-active');
        l.setAttribute('aria-hidden', 'true');
      });
      if (levelOne) levelOne.classList.remove('is-behind');
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ams-lock');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('.ams-drawer__top button');
      if (first) first.focus({ preventScroll: true });
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ams-lock');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      resetLevels();
      if (lastFocus) lastFocus.focus();
    }

    openers.forEach(function (o) { o.addEventListener('click', open); });
    drawer.querySelectorAll('[data-ams-drawer-close]').forEach(function (c) { c.addEventListener('click', close); });

    drawer.querySelectorAll('[data-ams-drill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var level = document.getElementById(btn.getAttribute('data-ams-drill'));
        if (!level) return;
        level.classList.add('is-active');
        level.setAttribute('aria-hidden', 'false');
        if (levelOne) levelOne.classList.add('is-behind');
        var back = level.querySelector('[data-ams-drill-back]');
        if (back) back.focus({ preventScroll: true });
        level.parentNode.scrollLeft = 0;
      });
    });

    drawer.querySelectorAll('[data-ams-drill-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var level = btn.closest('[data-level="2"]');
        resetLevels();
        var trigger = level && drawer.querySelector('[data-ams-drill="' + level.id + '"]');
        if (trigger) trigger.focus({ preventScroll: true });
        if (levelOne) levelOne.parentNode.scrollLeft = 0;
      });
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch(wrapper) {
    var input = wrapper.querySelector('input[type="search"]');
    var results = wrapper.querySelector('[data-ams-predictive]');
    if (!input || !results || !window.fetch) return;

    var currency = wrapper.getAttribute('data-currency') || 'RON';
    var quoteUrl = wrapper.getAttribute('data-quote-url');
    var formatter;
    try {
      formatter = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { formatter = null; }

    function money(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      var text = formatter ? formatter.format(n) : n.toFixed(2);
      return text + (currency === 'RON' ? ' lei' : ' ' + currency);
    }

    var timer;
    var controller;
    var lastQuery = '';

    function close() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var collections = r.collections || [];
      var pages = (r.pages || []).concat(r.articles || []);
      var html = '';

      if (collections.length) {
        html += '<div class="ams-predictive__group"><div class="ams-predictive__label">Categorii și branduri</div><ul class="ams-predictive__list" role="listbox">';
        collections.forEach(function (c) {
          html += '<li><a class="ams-predictive__item ams-predictive__item--text" role="option" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a></li>';
        });
        html += '</ul></div>';
      }

      if (products.length) {
        html += '<div class="ams-predictive__group"><div class="ams-predictive__label">Produse</div><ul class="ams-predictive__list" role="listbox">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + escapeHtml(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" loading="lazy" width="48" height="48">'
            : '<span></span>';
          html += '<li><a class="ams-predictive__item" role="option" href="' + escapeHtml(p.url) + '">' + img +
            '<span>' + escapeHtml(cleanTitle(p.title)) + (p.vendor ? '<br><small style="color:var(--ams-muted)">' + escapeHtml(p.vendor) + '</small>' : '') + '</span>' +
            '<span class="ams-predictive__price">' + escapeHtml(money(p.price)) + '</span></a></li>';
        });
        html += '</ul></div>';
      }

      if (pages.length) {
        html += '<div class="ams-predictive__group"><div class="ams-predictive__label">Informații și ghiduri</div><ul class="ams-predictive__list" role="listbox">';
        pages.forEach(function (pg) {
          html += '<li><a class="ams-predictive__item ams-predictive__item--text" role="option" href="' + escapeHtml(pg.url) + '">' + escapeHtml(pg.title) + '</a></li>';
        });
        html += '</ul></div>';
      }

      if (!html) {
        html = '<p class="ams-predictive__empty">Niciun rezultat pentru „' + escapeHtml(q) + '”. Încearcă un brand, un model sau un calibru.</p>';
        if (quoteUrl) {
          html += '<a class="ams-predictive__all" href="' + escapeHtml(quoteUrl) + '?produs=' + encodeURIComponent(q) + '">Nu-l găsești? Cere o ofertă pentru „' + escapeHtml(q) + '”</a>';
        }
      }

      html += '<a class="ams-predictive__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Vezi toate rezultatele pentru „' + escapeHtml(q) + '”</a>';
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(q) {
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) { if (q === lastQuery) render(q, data); })
        .catch(function (err) { if (!err || err.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQuery = q;
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () { search(q); }, 220);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML) {
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    wrapper.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(results.querySelectorAll('a'));
      var index = items.indexOf(document.activeElement);
      if (e.key === 'Escape') { close(); input.focus(); return; }
      if (results.hidden || !items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (items[index + 1] || items[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (index <= 0) input.focus(); else items[index - 1].focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) close();
    });
  }

  function init() {
    initNotify();
    var header = document.querySelector('[data-ams-header]');
    if (header) {
      initSticky(header);
      initMega(header);
    }
    initDrawer();
    document.querySelectorAll('[data-ams-search]').forEach(initSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
